import { render, staticRenderFns } from "./pasadyangSeting.vue?vue&type=template&id=274bf47e"
import script from "./pasadyangSeting.vue?vue&type=script&lang=js"
export * from "./pasadyangSeting.vue?vue&type=script&lang=js"
import style0 from "./pasadyangSeting.vue?vue&type=style&index=0&id=274bf47e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports